import { FC, useEffect, useState } from "react";
import { CancelPlacementRequest, PlacementDoc } from "../../../models/placements";
import { Tender } from "../../../models/tendering";
import { Dialog, DialogSurface, Title2, Title3, Text, DialogContent, Subtitle1, DialogActions, Button, Radio, RadioGroup, Field, Input, Textarea, Caption1, Spinner } from "@fluentui/react-components";
import { cancelPlacementRequest, updatePlacement } from "../../../services/placementService";

interface ContactTenderProps{
    isOpen:boolean;
    onClose: () => void;
    placement:PlacementDoc;
    placementDocID: string;
    cancelSent: (doc: PlacementDoc) => void;
}

export const CancelRequest: FC<ContactTenderProps> = ({
  isOpen,
  onClose,
  placement,
  placementDocID,
  cancelSent
}) => {
  const options = ["Behovet kvarstår inte", "Behovet har ändrats", "Behovet har tillgodosetts inom kommunens verksamhet", "Felaktig förfrågan, ny förfrågan kommer skickas ut", "Övrigt"];
  const [option, setOption] = useState<string | null>(null);
  const [comment, setComment] = useState<string | null>(null);
  const [error, setError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setComment(null);
    setError(false);
  }, [isOpen]);

  const onCancelPlacementRequest = async () => {
    if (!option) {
      setError(true);
      return;
    }
    setIsLoading(true);
    try {
      const updatedPlacement = {
        ...placement,
        status: 'cancelled',
        cancellationReason: option === "Övrigt" ? comment : option
      };
  
      await updatePlacement(updatedPlacement, placementDocID);
      cancelSent(updatedPlacement);
      const cancelRequest: CancelPlacementRequest = {
        placementRequestDocumentID: placementDocID,
        reason: option === "Övrigt" ? comment || "" : option
      };
      await cancelPlacementRequest(cancelRequest);

    } catch (error) {
      console.error('Error cancelling placement request:', error);
    } finally {
      setIsLoading(false);
      onClose();
    }
  }

  return (
    <Dialog open={isOpen} onOpenChange={(event, data) => !data.open && onClose()}>
      <DialogSurface>
        <DialogContent className="flex flex-col gap-2">
            <Subtitle1>Avbryt förfrågan</Subtitle1>
            <Text>Säker på att du vill avbryta förfrågan? <br /> Alla leverantörer kommer bli meddelande om nedan angiven orsak</Text>
            <Text className="mt-4" weight="semibold">Anledning för avbruten förfrågan:</Text>
            <Field required>
              <RadioGroup>
              {options.map(option => (
                <Radio key={option} value={option} label={option} onChange={(e) => {
                  setOption(e.target.value);
                  if (e.target.value !== "Övrigt") {
                    setComment(e.target.value);
                  }
                  else {
                    setComment(null);
                  }
                }} disabled={isLoading} />
              ))}
              </RadioGroup>
            </Field>
            {option == "Övrigt" && (
              <Field required>
                <Textarea resize="vertical" onChange={(e) => setComment(e.target.value)} disabled={isLoading} />
              </Field>
            )}
        </DialogContent>
        <DialogActions className="mt-8">
            <Button onClick={onClose} disabled={isLoading}>Nej, förtsätt</Button>
            
            {/* To continue with this after further instruction as mail template and so on */}
            <Button 
              appearance="primary" 
              onClick={onCancelPlacementRequest} 
              disabled={isLoading}
              icon={isLoading ? <Spinner size="tiny" /> : undefined}
            >
              {isLoading ? "Avbryter..." : "Ja, avbryt"}
            </Button>
        </DialogActions>
        <DialogActions className="mt-2">
            {error && (
              <Caption1 className="text-red-500">Måste välja ett alternativ</Caption1>
            )}
        </DialogActions>
      </DialogSurface>
    </Dialog>
  );
};


export default CancelRequest;